import React, { Component } from 'react';
import PropTypes from 'prop-types';
import config from 'config/config';
import { findDOMNode } from 'react-dom';
import { autobind } from 'core-decorators';
import ZeroClipboard from 'zeroclipboard';
import ClickToCopy from 'app/scripts/components/features/click-to-copy';
import { closest } from 'utils/dom';
import classnames from 'classnames';
import FAQ from '../common/faqs/conversation-setup';
import TitleAndDescription from '../common/title-and-description';
import SelectInput from '../common/inputs/select-input';

ZeroClipboard.config({ swfPath: config.zeroclipboard });

var PLATFORM_KEYS = {
  UNIVERSAL: { value: 'universal', text: 'Universal Code' },
  WORDPRESS: { value: 'wordpress', text: 'WordPress' }
};

function getPlatform(platform) {
  var result = null;
  switch (platform) {
    case PLATFORM_KEYS.WORDPRESS.value:
      return PLATFORM_KEYS.WORDPRESS;
    case PLATFORM_KEYS.UNIVERSAL.value:
      return PLATFORM_KEYS.UNIVERSAL;
  }

  return result;
}
class SocialKit extends Component {
  static displayName = 'SocialKit';

  static propTypes = {
    platform: PropTypes.string.isRequired,
    spotId: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      platform: props.platform,
      showCommentsOnly: false,
      showRecirculationOnly: false,
      showCommentsCount: false,
      disableReplies: false
    };
  }

  @autobind
  onPlatformChange(platform) {
    this.setState({ platform: platform.value });
  }

  getCommentsCountCode() {
    var coloredCode =
      '<span class="color4">&lt;span</span> <span class="color2">class</span>=<span class="color3">"spot-im-replies-count"</span> <span class="color2">data-post-id</span>=<span class="color3 yellow-background">"POST_ID"</span>&gt;<span class="color4">&lt;/span&gt;</span><br/>';
    var code = '<span class="spot-im-replies-count" data-post-id="POST_ID"></span>';

    return { html: coloredCode, code };
  }

  getConversationConfigCode(commentsOnly = false) {
    let { spotId } = this.props;
    var coloredCode = '';
    var code = '';

    if (!commentsOnly) {
      coloredCode =
        '<span class="color4">&lt;div</span> <span class="color2">data-spotim-module</span>=<span class="color3">"pitc"</span><span class="color4">&lt;/div&gt;</span><br/>';
      code = '<div data-spotim-module="pitc"></div>';
    }

    coloredCode += `<span class="color4">&lt;script</span> <span class="color2">async</span> <span class="color2">data-spotim-module</span>=<span class="color3">"spotim-launcher"</span><span class="color2"> src</span>=<span class="color3">"${config.api.launcherOnly}/spot/${spotId}"</span> <span class="color2">data-post-id</span>=<span class="color3 yellow-background">"POST_ID"</span>&gt;<span class="color4">&lt;/script&gt;</span>`;
    code += `<script async data-spotim-module="spotim-launcher" src="${config.api.launcherOnly}/spot/${spotId}" data-post-id="POST_ID"></script>`;

    return { html: coloredCode, code };
  }

  renderCode(data) {
    return (
      <div className="code-wrap">
        <span className="toast">Copied to clipboard</span>
        <div className="code">
          <ClickToCopy content={data.code} onCopy={this.toast} />
          <div className="gutter">
            <div className="line-numbers">
              1<br />2<br />3<br />4<br />5<br />6<br />7<br />8<br />9<br />
              10
              <br />
              11
              <br />
              12
              <br />
              13
              <br />
              14
              <br />
              15
              <br />
              16
              <br />
              17
              <br />
              18
              <br />
              19
              <br />
              20
              <br />
              21
              <br />
              22
              <br />
              23
              <br />
              24
              <br />
              25
              <br />
              26
              <br />
              27
              <br />
              28
              <br />
              29
              <br />
              30
            </div>
          </div>
          <div className="content" dangerouslySetInnerHTML={{ __html: data.html }} />
        </div>
      </div>
    );
  }

  toast(component) {
    var domNode = findDOMNode(component);
    var toastNode = closest(domNode, '.code-wrap').querySelector('.toast');
    toastNode.className = 'toast animate';
    setTimeout(() => {
      toastNode.className = 'toast';
    }, 3000);
  }

  @autobind
  onAdvancedOptionClick(advancedOption) {
    let { showCommentsOnly, showRecirculationOnly, showCommentsCount, disableReplies } = this.state;
    switch (advancedOption) {
      case 'showCommentsOnly':
        this.setState({ showCommentsOnly: !showCommentsOnly });
        break;
      case 'showRecirculationOnly':
        this.setState({ showRecirculationOnly: !showRecirculationOnly });
        break;
      case 'showCommentsCount':
        this.setState({ showCommentsCount: !showCommentsCount });
        break;
      case 'disableReplies':
        this.setState({ disableReplies: !disableReplies });
        break;
    }
  }

  getSpotCode(spotId) {
    var launcher = config.api.launcher;
    var html1 =
      '<span class="color4">&lt;script</span> <span class="color2">type</span>=<span class="color3">"text/javascript"</span>&gt;';
    var html2 =
      '!<span class="color1">function</span>(<span class="color2">t</span>,<span class="color2">e</span>,<span class="color2">n</span>){<br/><span class="color1">function</span> <span class="color2">a</span>(<span class="color2">t</span>){<span class="color1">var&nbsp;</span> <span class="color2">a</span>=e.createElement(<span class="color3">"script"</span>);<span>a</span>.type=<span class="color3">"text/javascript"</span> ,<span class="color2">a</span>.async=!<span class="color4">1</span>,<span class="color2">a</span>.src=(<span class="color3">"https:"</span>===e.location.protocol?<span class="color3">"https"</span>:<span class="color3">"http"</span>)+<span class="color3">":"</span>+n,(<span>t</span>||e.body||e.head).appendChild(<span class="color2">a</span>)}<span class="color1">function</span> <span class="color2">o</span>(){<span class="color1">var&nbsp;</span> <span class="color2">t</span>=e.getElementsByTagName(<span class="color3">"script"</span>),<span class="color2">n</span>=<span class="color2">t</span>[<span class="color2">t</span>.length-<span class="color4">1</span>];<span class="color1">return</span> <span class="color2">n</span>.parentNode} <span class="color1">var&nbsp;</span> <span class="color2">p</span>=<span class="color2">o</span>();<span class="color2">t</span>.spotId=<span class="color3">"{{SPOT_ID}}"</span>,<span class="color2">t</span>.parentElement=<span class="color2">p</span>,<span class="color2">a</span>(<span class="color2">p</span>)}(window.SPOTIM={},document,<span class="color3">"' +
      launcher +
      '"</span>);';
    html2 = html2.replace('{{SPOT_ID}}', spotId);
    var html3 = '<span class="color4">&lt;/script&gt;</span>';
    var coloredCode = '<div>' + html1 + html2 + html3 + '</div>';
    var code =
      '<script type="text/javascript">!function(t,e,n){function a(t){var a=e.createElement("script");a.type="text/javascript",a.async=!1,a.src=("https:"===e.location.protocol?"https":"http")+":"+n,(t||e.body||e.head).appendChild(a)}function o(){var t=e.getElementsByTagName("script"),n=t[t.length-1];return n.parentNode} var p=o();t.spotId="{{SPOT_ID}}",t.parentElement=p,a(p)}(window.SPOTIM={},document,"' +
      launcher +
      '");</script>';
    code = code.replace('{{SPOT_ID}}', spotId);
    return {
      html: coloredCode,
      code
    };
  }

  renderWordPress() {
    return (
      <div className="code-section">
        <div className="code-wrapper">
          <div className="code-title">Wordpress Setup Instructions</div>
          <div>
            <p>
              1. In your WordPress admin dashboard, select <strong>Plugins &gt; Add New </strong>{' '}
              from the left-hand navigation pane.
            </p>
            <p>
              2. Type "Spot.IM Comments" in the search field, and select the plugin of that same
              name.
            </p>
            <p>
              3. On the plugin page, click <strong> Install Now</strong>, located in the lower
              right-hand corner. You will be brought to the installation page.
            </p>
            <p>
              4. On the installation page, click <strong>Activate Plugin</strong>.
            </p>
            <p>
              5. Copy the unique Spot ID below and paste it in your Spot.IM Settings page, located
              in your WordPress dashboard <strong>(Settings &gt; Spot.IM Settings).</strong>
            </p>
            {this.renderCode(this.getSpotIdCode())}
          </div>
        </div>
      </div>
    );
  }

  getSpotIdCode() {
    var coloredCode = `<span class="color3">${this.props.spotId}</span>`;
    var code = this.props.spotId;
    return { html: coloredCode, code };
  }

  render() {
    let {
      platform,
      showCommentsOnly,
      showCommentsCount,
      showRecirculationOnly,
      disableReplies
    } = this.state;
    let codeComponent = null;
    if (platform) {
      switch (platform) {
        case PLATFORM_KEYS.WORDPRESS.value:
          codeComponent = this.renderWordPress();
          break;
        case PLATFORM_KEYS.UNIVERSAL.value:
          codeComponent = (
            <div>
              {this.renderCode(this.getConversationConfigCode())}
              <p>
                On each page you need to place a unique ID to display a Real-Time Conversation
                specific to that page. Please replace{' '}
                <span className="head-tag">&nbsp;"POST_ID"&nbsp;</span> with your own ID.
              </p>
            </div>
          );
          break;
      }
    }

    return (
      <div className="social-kit">
        <div className="main-section-social-kit">
          <div className="embed-section">
            <h3>OpenWeb Social Kit</h3>
            <p>Two amazing features combined.</p>
            <p>
              Power conversation with <b>Real-Time Conversation</b>, a lightweight and fully
              customizable module to inspire your audience to engage. Complete with automatic
              moderation for illicit chatter, Real-Time Conversation will help boost pageviews and
              SEO rankings.
            </p>
            <p>
              <b>Community Recirculation</b> promotes the most popular content from your site by
              showcasing user-generated content (UGC). This unit drives users to more of your
              content and features a monetization component so you can generate meaningful revenue
              via revshare.
            </p>
            <div className="image-continer">
              <img src="https://publisher-assets.spot.im/host-panel/social-kit.png" />
            </div>
            <SelectInput
              title="Select your site platform"
              onChange={this.onPlatformChange}
              options={[PLATFORM_KEYS.UNIVERSAL, PLATFORM_KEYS.WORDPRESS]}
              value={getPlatform(platform)}
            />
            {platform === PLATFORM_KEYS.UNIVERSAL.value && (
              <TitleAndDescription
                title="Code for Your Site"
                description={
                  <span>
                    Place this code where you’d like the <b>Social Kit</b> to display on your pages.
                  </span>
                }
              />
            )}
            {codeComponent}
          </div>
          {platform === PLATFORM_KEYS.UNIVERSAL.value && (
            <div className="advanced-options">
              <h5 className="advanced-title"> Advanced Options </h5>
              <div className={classnames('advanced-link-container', { active: showCommentsOnly })}>
                <span
                  className={showCommentsOnly ? 'regular-link' : 'link'}
                  onClick={this.onAdvancedOptionClick.bind(this, 'showCommentsOnly')}
                >
                  Display Real-Time Conversation Only
                </span>
                {showCommentsOnly && (
                  <div>
                    <p>
                      Place this code where you’d like the <b>Real-Time Conversation</b> to display
                      on your pages.
                    </p>
                    {this.renderCode(this.getConversationConfigCode(true))}
                    <p>
                      On each page you need to place a unique ID to display a Real-Time Conversation
                      specific to that page. Please replace{' '}
                      <span className="head-tag">&nbsp;"POST_ID"&nbsp;</span> with your own ID.
                    </p>
                  </div>
                )}
              </div>
              <div
                className={classnames('advanced-link-container', { active: showRecirculationOnly })}
              >
                <span
                  className={showRecirculationOnly ? 'regular-link' : 'link'}
                  onClick={this.onAdvancedOptionClick.bind(this, 'showRecirculationOnly')}
                >
                  Display Community Recirculation only
                </span>
                {showRecirculationOnly && (
                  <p>
                    Please contact{' '}
                    <a className="support-link" href="mailto:support@spot.im">
                      support@spot.im
                    </a>{' '}
                    to get the code of the <b>Community Recirculation.</b>
                  </p>
                )}
              </div>
              <div className={classnames('advanced-link-container', { active: showCommentsCount })}>
                <span
                  className={showCommentsCount ? 'regular-link' : 'link'}
                  onClick={this.onAdvancedOptionClick.bind(this, 'showCommentsCount')}
                >
                  Display Comments Count
                </span>
                {showCommentsCount && (
                  <div>
                    <p>
                      Place this code where you’d like the comments count for a specific Real-Time
                      Conversation to display on your pages.
                    </p>
                    {this.renderCode(this.getCommentsCountCode())}
                    <p>
                      Replace <span className="head-tag">&nbsp;"POST_ID"&nbsp;</span> with your ID
                      of the page you want to see comments count for.
                    </p>
                  </div>
                )}
              </div>
              <div className={classnames('advanced-link-container', { active: disableReplies })}>
                <span
                  className={disableReplies ? 'regular-link' : 'link'}
                  onClick={this.onAdvancedOptionClick.bind(this, 'disableReplies')}
                >
                  Disable Replies to Comments
                </span>
                {disableReplies && (
                  <p>
                    Please contact{' '}
                    <a className="support-link" href="mailto:support@spot.im">
                      publisherfirst@openweb.com
                    </a>{' '}
                    to remove the option for users to reply to comments.
                  </p>
                )}
              </div>
            </div>
          )}
        </div>
        <FAQ />
      </div>
    );
  }
}

export default SocialKit;
